/* ============================================================
   SPIDERCARD 共用元件互動（NFC 商城頁與部落格共用；2026-10-15 由 spidercard-nfc-shop.js 拆出，程式內容不變）
   導覽列捲動樣式、手機選單、語系抽屜。對應 snippets/sc-header.liquid、sc-language-drawer.liquid。
   需在頁面專屬程式之前載入（defer 依序執行）。
   ============================================================ */
/* ============================================================
   導覽列：滾動固定樣式 + 手機選單
   ============================================================ */
const nav = document.getElementById('nav');
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');

/**
 * 依滾動位置切換導覽列的固定半透明樣式
 * @returns {void}
 */
function updateNavOnScroll() {
  nav.classList.toggle('scrolled', window.scrollY > 24);
}
window.addEventListener('scroll', updateNavOnScroll, { passive: true });
updateNavOnScroll();

function closeMobileMenu() {
  mobileMenu.classList.remove('open');
  document.body.classList.remove('mobile-menu-open');
  burger.setAttribute('aria-expanded', 'false');
}


burger.setAttribute('aria-expanded', 'false');
burger.setAttribute('aria-controls', 'mobileMenu');
burger.addEventListener('click', () => {
  closeLanguageDrawer();
  const isOpen = mobileMenu.classList.toggle('open');
  document.body.classList.toggle('mobile-menu-open', isOpen);
  burger.setAttribute('aria-expanded', String(isOpen));
});
/* 斷點切換才處理（不用 resize：手機網址列收合也會觸發 resize，會誤關語系抽屜、焦點跳回舊元素）：
   切到桌機寬度關手機選單；切到手機寬度時，語系抽屜開著才關 */
const compactViewport = window.matchMedia('(max-width:1024px)');
compactViewport.addEventListener('change', (e) => {
  if (e.matches) closeLanguageDrawer();
  else closeMobileMenu();
});

/* ============================================================
   語系抽屜（與 dan_workspace 三站統一的互動規格）
   視覺與 aria 行為比照三站；語言清單與送出邏輯維持 Shopify
   localization 表單，選擇後會實際換頁到對應語系網址。
   ============================================================ */
const languageToggle = document.getElementById('nfcLanguageToggle');
const languageDrawer = document.getElementById('nfcLanguageDrawer');
let languageLastFocus = null;

/**
 * 開啟語系抽屜，並把焦點移到目前選取的語言。
 * @returns {void}
 */
function openLanguageDrawer() {
  if (!languageDrawer) return;
  languageLastFocus = document.activeElement;
  languageDrawer.classList.add('is-open');
  languageDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('language-open');
  if (languageToggle) languageToggle.setAttribute('aria-expanded', 'true');
  const selected = languageDrawer.querySelector('[aria-pressed="true"]') || languageDrawer.querySelector('button[name="locale_code"]');
  if (selected) selected.focus();
}

/**
 * 關閉語系抽屜，並把焦點還給觸發的按鈕。抽屜沒開時不做事（避免把焦點拉回舊元素）。
 * @returns {void}
 */
function closeLanguageDrawer() {
  if (!languageDrawer || !languageDrawer.classList.contains('is-open')) return;
  languageDrawer.classList.remove('is-open');
  languageDrawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('language-open');
  if (languageToggle) languageToggle.setAttribute('aria-expanded', 'false');
  if (languageLastFocus) languageLastFocus.focus();
  languageLastFocus = null;
}

if (languageToggle) languageToggle.addEventListener('click', openLanguageDrawer);
if (languageDrawer) {
  languageDrawer.querySelector('.language-backdrop').addEventListener('click', closeLanguageDrawer);
  languageDrawer.querySelectorAll('[data-language-close]').forEach((button) => {
    button.addEventListener('click', closeLanguageDrawer);
  });
}
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && languageDrawer && languageDrawer.classList.contains('is-open')) closeLanguageDrawer();
});

/* 手機版隱藏導覽列語系鈕，改由手機選單的入口開啟抽屜。 */
const mobileLanguageToggle = document.getElementById('mobileLangToggle');
if (mobileLanguageToggle) {
  mobileLanguageToggle.addEventListener('click', () => {
    closeMobileMenu();
    openLanguageDrawer();
  });
}
